export default __webpack_public_path__ + "static/media/flask.6abdf6e8.svg";